import React, { PropsWithChildren, MouseEvent } from "react";

import "./SignpostArrow.css";

interface Props {
    text?: string;
    arrowColor: string;
    backgroundColor: string;
    className: string;
    type: "left" | "right";
    onClick: (e: MouseEvent) => void;
}

const SignpostArrow: React.FC<Props> = function ({
    text,
    arrowColor,
    backgroundColor,
    className,
    type,
    onClick,
    children
}: PropsWithChildren<Props>) {
    const shapeColor = type === "left" ? arrowColor : backgroundColor;

    const handleOnClick = (e: MouseEvent): void => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
    };

    return (
        <div className={`signpost_arrow ${className} ${type}`} onClick={handleOnClick}>
            <div className="signpost_arrow__text" style={{ backgroundColor: arrowColor }}>
                {text}
                {children}
            </div>
            <div
                className="signpost_arrow__arrow"
                style={{ borderColor: `${shapeColor} ${shapeColor} transparent transparent` }}
            />
        </div>
    );
};

export default SignpostArrow;
